import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import authService from '&/services/authService.js'
import sessionService from '&/services/sessionService.js'
import toastPlugin from './plugins/toast.js'

// Importar Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Importar FontAwesome
import '@fortawesome/fontawesome-free/css/all.min.css'

import './style.css'

// Función para manejar la altura del viewport en móviles
function setViewportHeight() {
  // Usar la altura real del viewport
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
  
  // Calcular la altura de la aplicación
  const appHeight = window.innerHeight
  document.documentElement.style.setProperty('--app-height', `${appHeight}px`)
}

// Configurar la altura inicial
setViewportHeight()

// Actualizar la altura cuando cambie el viewport (especialmente en móviles)
window.addEventListener('resize', setViewportHeight)
window.addEventListener('orientationchange', () => {
  // Pequeño delay para que el navegador ajuste las dimensiones
  setTimeout(setViewportHeight, 100)
})

// Inicializar sessionService primero para generar sessionId
console.log('🚀 Inicializando aplicación ldda-app...')
const sessionId = sessionService.getSessionId()
console.log('🆔 Session ID inicializado:', sessionId)

// Debug de cookies
const cookieDebug = sessionService.debugCookies()
console.log('🔍 Estado de cookies:', cookieDebug)

// Configurar authService para modo app (por defecto, pero explícito)
authService.setAdminMode(false)

// El token anónimo se inicializa automáticamente al configurar modo app
console.log('🔑 Sistema de autenticación configurado para app')

const app = createApp(App)

app.use(router)
app.use(toastPlugin)

app.mount('#app')
